import { PencilSimple, Plus } from "@phosphor-icons/react"
import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"
import { useIsInContextOfAppointment } from "@/modules/patients/hooks/useAppointmentParam"

interface EpisodeOfCareActionsProps extends React.ComponentPropsWithoutRef<"div"> {
  disabled?: boolean
  onEdit: () => void
  onCreateProgressNote: () => void
}

const EpisodeOfCareActions = ({
  className,
  disabled,
  onEdit,
  onCreateProgressNote,
  ...restProps
}: EpisodeOfCareActionsProps) => {
  const isInContextOfAppointment = useIsInContextOfAppointment()

  return (
    <div className={cn("ml-auto inline-flex", className)} {...restProps}>
      <Button onClick={onEdit} variant="circle" className="h-10 w-10" data-testid="edit-episode-of-care-btn">
        <PencilSimple className="text-on-surface-subdued" />
      </Button>
      {isInContextOfAppointment && (
        <Button
          variant="circle"
          className="h-10 w-10"
          data-testid="create-episode-of-care-btn"
          disabled={disabled}
          onClick={onCreateProgressNote}>
          <Plus className="text-on-surface-subdued" />
        </Button>
      )}
    </div>
  )
}

export { EpisodeOfCareActions }
